import apiClient from '../utils/apiClient';

/**
 * Configuration API Services
 * Quản lý cấu hình hệ thống
 */

export const configurationAPI = {
  /**
   * Lấy danh sách configuration với phân trang và lọc
   * @param {Object} params - Tham số truy vấn
   * @param {string} params.category - Lọc theo danh mục (POINT, ATTENDANCE, PAYROLL, SHIFT, PERFORMANCE)
   * @param {string} params.branch_id - Lọc theo chi nhánh (hoặc null để lấy global)
   * @param {boolean} params.is_active - Lọc theo trạng thái hoạt động
   * @param {string} params.type - Lọc theo kiểu dữ liệu (NUMBER, STRING, JSON, BOOLEAN, ARRAY)
   * @param {string} params.search - Tìm kiếm theo key hoặc description
   * @returns {Promise<Object>} Danh sách configuration
   */
  getConfigurations: async (params = {}) => {
    const {
      category = '',
      branch_id = '',
      is_active = '',
      type = '',
      search = '',
    } = params;
    return await apiClient.get({
      url: '/configurations',
      params: { category, branch_id, is_active, type, search },
    });
  },

  /**
   * Lấy thông tin chi tiết configuration theo ID
   * @param {string} configId - ID configuration
   * @returns {Promise<Object>} Thông tin chi tiết configuration
   */
  getConfigurationById: async (configId) => {
    return await apiClient.get({
      url: `/configurations/${configId}`,
    });
  },

  /**
   * Lấy configuration theo key (không cần authentication)
   * @param {string} key - Key của configuration
   * @returns {Promise<Object>} Thông tin configuration
   */
  getConfigurationByKey: async (key) => {
    return await apiClient.get({
      url: `/configurations/key/${key}`,
    });
  },

  /**
   * Tạo configuration mới
   * @param {Object} configData - Dữ liệu configuration
   * @param {string} configData.key - Key của config (unique, max 100 chars)
   * @param {string} configData.value - Giá trị (sẽ được validate theo type)
   * @param {string} configData.type - NUMBER, STRING, JSON, BOOLEAN, ARRAY
   * @param {string} configData.category - Danh mục (max 50 chars)
   * @param {string} configData.description - Mô tả (max 500 chars, optional)
   * @param {string} configData.branch_id - ID chi nhánh (null = global, optional)
   * @param {boolean} configData.is_active - Trạng thái (default: true, optional)
   * @returns {Promise<Object>} Thông tin configuration vừa tạo
   */
  createConfiguration: async (configData) => {
    return await apiClient.post({
      url: '/configurations',
      data: configData,
    });
  },

  /**
   * Cập nhật configuration
   * @param {string} configId - ID configuration
   * @param {Object} updateData - Dữ liệu cập nhật (tất cả fields đều optional)
   * @param {string} updateData.value - Giá trị (optional)
   * @param {string} updateData.description - Mô tả (optional)
   * @param {string} updateData.branch_id - ID chi nhánh (optional)
   * @param {boolean} updateData.is_active - Trạng thái (optional)
   * @returns {Promise<Object>} Thông tin configuration sau khi cập nhật
   */
  updateConfiguration: async (configId, updateData) => {
    return await apiClient.put({
      url: `/configurations/${configId}`,
      data: updateData,
    });
  },

  /**
   * Xóa configuration
   * @param {string} configId - ID configuration
   * @returns {Promise<Object>} Kết quả xóa
   */
  deleteConfiguration: async (configId) => {
    return await apiClient.delete({
      url: `/configurations/${configId}`,
    });
  },

  /**
   * Bật/Tắt configuration
   * @param {string} configId - ID configuration
   * @returns {Promise<Object>} Thông tin configuration sau khi toggle
   */
  toggleActive: async (configId) => {
    return await apiClient.patch({
      url: `/configurations/${configId}/toggle-active`,
    });
  },
};

